import { Expose, Transform } from "class-transformer";
import { toCents, toMonths } from "@/utils/numberUtils";
import {
  HierarchicalLevelEnum,
  QualificationRenewalModeEnum,
  TrainingModalityEnum,
  TrainingTypologyEnum,
} from "@altertec_gparn/lib";

export class CreateQualificationDto {
  @Expose()
  name: string;

  @Expose()
  @Transform(({ value }) => toMonths(value))
  durationInYears: number;

  @Expose()
  @Transform(({ value }) => toMonths(value))
  expirationInYears?: number;

  @Expose()
  isMandatoryForAllTechnicians: boolean;

  @Expose()
  trainingCategoryId?: string;

  @Expose()
  trainingCode?: string;

  @Expose()
  typology?: TrainingTypologyEnum;

  @Expose()
  modality?: TrainingModalityEnum;

  @Expose()
  hierarchicalLevel?: HierarchicalLevelEnum;

  @Expose()
  clientIds?: string[];

  @Expose()
  @Transform(({ value }) => (value ? toCents(value) : value))
  cost?: number;

  @Expose()
  hours?: number;

  @Expose()
  elevatorIds?: string[];

  @Expose()
  taskTypeIds?: string[];

  @Expose()
  allTaskTypes: boolean;

  @Expose()
  renewalMode?: QualificationRenewalModeEnum;

  @Expose()
  recyclingQualificationId?: string | null;
}
